import TextField from '@material-ui/core/TextField'
import Division from './Division'

import Fragment from './Fragment'

import withWidth, { isWidthUp } from '@material-ui/core/withWidth'
import { formValidation } from '../helpers'
import { FORM_ERROR_TEXT, FORM_LABELS, FORMS } from '../constants'
import Collapse from '@material-ui/core/Collapse'
import FormSubmit from './FormSubmit'

const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  fieldContainer: (props) => ({
    backgroundColor: props.standalone ? theme.palette.primary.light : 'transparent',
    padding: props.standalone
      ? isWidthUp('md', props.width)
        ? '70px 20px'
        : '20px 20px 10px 20px'
      : 0,
  }),
  whiteText: {
    color: 'white',
  },
  form: {
    padding: '20px 0',
  },
  input: {
    backgroundColor: 'white',
    marginBottom: 15,
  },
  buttonContainer: (props) => ({
    width: '100%',
    padding: props.standalone ? 20 : 0,
    textAlign: 'center',
  }),
  button: {
    maxWidth: 350,
  },
}))

const SignUp = ({ standalone, contrast, width, onSuccess, onFail, linkOnly }) => {
  const classes = useStyles({ width, standalone })
  const [formData, setFormData] = useState(FORMS.signup.fields)
  const [formErrors, setFormErrors] = useState(
    _.mapValues(FORMS.signup.fields, () => null)
  )
  const fragments = useSelector((state) => state.local.fragments)
  const [submitted, setSubmitted] = useState(false)
  const formRefs = _.mapValues(FORMS.signup.fields, () => React.useRef())
  const rsv = standalone ? { xs: 12, sm: 12, md: 10, lg: 9 } : { xs: 12 }

  const update = (prop, evt) => {
    setFormErrors(_.mapValues(FORMS.signup.fields, () => null))
    setFormData({ ...formData, [prop]: evt.target.value })
  }

  const submit = (evt) => {
    if (!evt || !evt.key || evt.key === 'Enter') {
      const res = formValidation(formRefs, formErrors)
      if (res.valid) {
        setSubmitted(true)
      } else {
        setFormErrors(res.errors)
      }
    }
  }

  return (
    <Collapse in={!_.isEmpty(fragments)}>
      <Grid container item justify="center">
        <FormSubmit
          submit={submitted}
          postRoute="/api/signup"
          postData={{ signup: formData }}
          onSuccess={onSuccess}
          onFail={onFail}
          contrast={contrast}
        />
        {!submitted && (
          <Grid
            item
            container
            xs={12}
            sm={10}
            className={classes.fieldContainer}
            justify="center"
          >
            <Grid item {...rsv}>
              <Typography
                variant="h4"
                className={contrast ? '' : classes.whiteText}
                align="center"
              >
                <Fragment
                  title={`signup_${standalone ? 'standalone_' : ''}title`}
                  {...{ fragments }}
                />
              </Typography>
              <Division white={!contrast} padding={15} />
              <Typography
                variant="h5"
                className={contrast ? '' : classes.whiteText}
                align="center"
              >
                <Fragment
                  title={`signup_${standalone ? 'standalone_' : ''}paragraph`}
                  {...{ fragments }}
                />
              </Typography>
              {!linkOnly && (
                <form className={classes.form}>
                  <TextField
                    inputRef={formRefs.first_name}
                    error={formErrors['first_name']}
                    placeholder={FORM_LABELS.first_name}
                    variant="outlined"
                    helperText={formErrors.first_name && FORM_ERROR_TEXT.first_name}
                    fullWidth
                    required
                    name="first_name"
                    autoComplete="given-name"
                    className={classes.input}
                    value={formData.first_name}
                    onChange={(e) => update('first_name', e)}
                    onKeyDown={submit}
                  />
                  <TextField
                    inputRef={formRefs.email}
                    error={formErrors.email}
                    placeholder={FORM_LABELS.email}
                    helperText={formErrors.email && FORM_ERROR_TEXT.email}
                    variant="outlined"
                    fullWidth
                    required
                    type="email"
                    name="email"
                    autoComplete="email"
                    className={classes.input}
                    value={formData.email}
                    onChange={(e) => update('email', e)}
                    onKeyDown={submit}
                  />
                  {standalone && (
                    <Typography variant="body1" color="textSecondary" align="center">
                      <i>
                        <Fragment title="signup_form_disclaimer" {...{ fragments }} />
                      </i>
                    </Typography>
                  )}
                </form>
              )}
            </Grid>
          </Grid>
        )}
        {!submitted && (
          <Grid xs={12} item className={classes.buttonContainer}>
            <Button
              color={'secondary'}
              variant="contained"
              size="large"
              fullWidth
              onClick={linkOnly ? () => (window.location.href = '/join') : submit}
              className={classes.button}
            >
              <Fragment
                title={`signup_${standalone ? 'standalone_' : ''}button`}
                {...{ fragments }}
              />
            </Button>
          </Grid>
        )}
      </Grid>
    </Collapse>
  )
}

export default withWidth()(SignUp)
